import { useEffect, useState } from 'react';
import { ENTRANCE_DURATION_MS } from '../constants';

interface Args {
  isActive: boolean;
  reduceMotion: boolean | null;
  onLoad?: () => void;
}

export default function useWidgetEntrance({ isActive, reduceMotion, onLoad }: Args) {
  const [isEntering, setIsEntering] = useState(isActive && !reduceMotion);

  useEffect(() => {
    if (isActive) onLoad?.();
  }, [isActive, onLoad]);

  useEffect(() => {
    if (!isActive || reduceMotion) return undefined;

    const frame = requestAnimationFrame(() => setIsEntering(true));
    const timeout = setTimeout(() => setIsEntering(false), ENTRANCE_DURATION_MS);
    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
    };
  }, [isActive, reduceMotion]);

  return isActive && !reduceMotion && isEntering;
}
